import { useEffect, useMemo } from 'react';
import _isBoolean from 'lodash/isBoolean';
import { useDrawerContext } from '../context';

type UseDrawerGlobalLoaderResult = {
  isLoading: boolean;
};

const useDrawerGlobalLoader = (loading?: boolean): UseDrawerGlobalLoaderResult => {
  const { isLoading, setLoading } = useDrawerContext();

  useEffect(() => {
    if (_isBoolean(loading)) {
      setLoading(Boolean(loading));
    }
  }, [loading]);

  return useMemo(
    () => ({
      isLoading,
    }),
    [isLoading]
  );
};

export default useDrawerGlobalLoader;
